module.exports = __webpack_public_path__ + "static/media/stacked-column-chart-b-CR07.0283951a.png";